import React from 'react'
import { MdStar } from 'react-icons/md'

import Button from './Button'
import { classNames } from '../services/string'
import { useAnalytics } from '../hooks'
import WhatsAppButton from './WhatsAppButton'

export interface IDetailedCustomerReviewCardProps {
  className?: string
  review: Queries.ReviewInfoFragment
}

const DetailedCustomerReviewCard = ({ className, review }: IDetailedCustomerReviewCardProps) => {
  const { fireEvent } = useAnalytics()

  // Disparo do evento de clique externo
  const fireAnalyticsEvent = () => {
    fireEvent('send_contact', { component: 'DetailedCustomerReviewCard', target: 'linkWhatsapp' })

    fireEvent('externalClick', {
      component: 'DetailedCustomerReviewCard',
      target: 'linkWhatsapp',
    })
  }

  return (
    <div
      className={classNames(
        className,
        'rounded-2xl flex flex-col justify-between p-8 h-auto gap-4 bg-white/50 shadow-[1px_1px_1px_0px_rgba(255,255,255,1)_inset] text-black',
      )}
    >
      <div className='flex flex-col gap-2'>
        <p className='font-medium text-xl'>"{review.title}"</p>

        <div className='flex gap-1 text-primary-600'>
          {[...Array(5)].map((_v, i) => (
            <MdStar key={i} size={25} />
          ))}
        </div>
      </div>
      <p className='text-lg'>"{review.content}"</p>

      <WhatsAppButton className='w-fit' onClick={() => fireAnalyticsEvent()}>
        <Button size='lg' className='!drop-shadow-xs'>
          Eu também quero ser Cliente Hubs!
        </Button>
      </WhatsAppButton>
    </div>
  )
}

export default DetailedCustomerReviewCard
